import Link from 'next/link';
import { useRouter } from 'next/router';

import { H5 } from '@common/headline';

export const RecipesAndGuidesMenu = (): JSX.Element => {
  const { asPath } = useRouter();

  const isActive = (path: string): boolean => asPath.includes(path);
  const isGuidesHomePage = () => asPath === '/guides';

  const activeStyle =
    'flex border-b-2 border-dawn-blue text-dawn-blue h-[72px] lg:h-[96px] items-center';

  return (
    <div className="container m-auto flex items-center justify-between gap-x-6 overflow-auto whitespace-nowrap bg-mono-white px-3 text-mono-grey lg:px-[60px]">
      <Link href="/guides" className={isGuidesHomePage() ? activeStyle : ''}>
        <H5>All</H5>
      </Link>
      <Link
        href="/guides/category/nutrition"
        className={isActive('nutrition') ? activeStyle : ''}
      >
        <H5>Nutrition</H5>
      </Link>
      <Link href="/blog" className={isActive('blog') ? activeStyle : ''}>
        <H5>Blog</H5>
      </Link>
      <Link
        href="/guides/category/diabetes"
        className={isActive('diabetes') ? activeStyle : ''}
      >
        <H5>Diabetes</H5>
      </Link>
      <Link
        href="/guides/category/exercise"
        className={isActive('exercise') ? activeStyle : ''}
      >
        <H5>Exercise</H5>
      </Link>
      <Link
        href="/guides/category/lifestyle"
        className={isActive('lifestyle') ? activeStyle : ''}
      >
        <H5>Lifestyle</H5>
      </Link>
      <Link
        href="/guides/category/mind"
        className={isActive('mind') ? activeStyle : ''}
      >
        <H5>Mind</H5>
      </Link>
      <Link
        href="/guides/category/myth-busting"
        className={isActive('myth-busting') ? activeStyle : ''}
      >
        <H5>Myth Busting</H5>
      </Link>
      <Link
        href="/guides/category/recipes"
        className={isActive('recipes') ? activeStyle : ''}
      >
        <H5>Recipes</H5>
      </Link>
      <Link
        href="/guides/category/sleeping"
        className={isActive('sleeping') ? activeStyle : ''}
      >
        <H5>Sleeping</H5>
      </Link>
    </div>
  );
};
